import PropTypes from 'prop-types';
import React from 'react';
import {observer} from 'mobx-react';
import {ANCILLARY_HCF_TEXT} from 'core/constants.js';
import {DirectoryStoreContext} from 'core/stores/RootStore.js';
import {NotificationV2} from '@HealthShareAU/hs-component-library';

export default
@observer
class HealthFundDisclaimerV2 extends React.Component {
    static contextType = DirectoryStoreContext;

    static propTypes = {
        main: PropTypes.bool,
    };

    static defaultProps = {
        main: false,
    };

    decodeAndStripTags(htmlString) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        const decodedText = tempDiv.textContent || tempDiv.innerText || '';
        return decodedText;
    }

    getDisclaimerText(name) {
        const {
            rootStore: {
                healthFundStore: {
                    healthFund: {searchResultsDisclaimerText},
                },
            },
            healthFundBannerAds,
        } = this.context;

        let disclaimer = `Consultations with these practitioners may be eligible for <strong>${name}</strong> rebate when members have applicable Extras cover`;

        if (searchResultsDisclaimerText && !healthFundBannerAds?.length) {
            disclaimer = `${disclaimer}. \n${searchResultsDisclaimerText}`;
        }

        return disclaimer;
    }

    // Return showAllSpecialtiesSearchResults text if target specialty is
    // contained within showAllSpecialties list.
    // Otherwise if specialty is of type medical return the searchResultsText
    // Otherwise return the default disclaimer text.
    getSearchResultsText() {
        const {
            rootStore: {
                healthFundStore: {healthFund},
            },
            specialty,
            bannerAds,
            healthFundBannerAds,
        } = this.context;
        const {
            name,
            searchResultsText,
            showAllSpecialties,
            showAllSpecialtiesSearchResultsText,
            searchResultsDisclaimerText,
        } = healthFund;
        let searchResultsDisplayText = `${searchResultsText}. \n${
            healthFundBannerAds?.length ? '' : searchResultsDisclaimerText
        }`;
        if (showAllSpecialties && showAllSpecialties.includes(specialty.id)) {
            const isHFExist = healthFundBannerAds?.length > 0;
            searchResultsDisplayText = `${showAllSpecialtiesSearchResultsText} ${
                isHFExist ? '' : searchResultsDisclaimerText
            } `;
        } else {
            const isAncillarySpecialty = !specialty?.isSpecialist; // is_specialist = false

            if (!specialty.isMedical || !searchResultsDisplayText) {
                searchResultsDisplayText = this.getDisclaimerText(name);

                // Only for HCF
                if (isAncillarySpecialty && healthFund?.id === 1) {
                    searchResultsDisplayText = `${ANCILLARY_HCF_TEXT} ${
                        healthFundBannerAds?.length
                            ? ''
                            : searchResultsDisclaimerText
                    }`;
                }
            }
        }
        return searchResultsDisplayText;
    }

    render() {
        const {
            bannerAdsHaveLoaded,
            bannerAds,
            healthFundBannerAds,
            locationSearchAPI,
            searchResultsError,
            rootStore: {
                healthFundStore: {healthFund, healthFundThemeColor},
                paramStore: {hasSkin},
            },
        } = this.context;
        if (
            !healthFund?.name ||
            searchResultsError ||
            (!bannerAds.length && !locationSearchAPI.results?.length) ||
            !bannerAdsHaveLoaded
        ) {
            return null;
        }
        const {avatar, searchResultsDisclaimerText} = healthFund;
        const sRT = this.getSearchResultsText();
        return (
            <>
                {this.props.main ? (
                    <NotificationV2
                        customClass="notification-banner main"
                        colorTheme={healthFundThemeColor}
                        htmlText={sRT}
                        displayImage={<img src={avatar} />}
                    />
                ) : (
                    healthFundBannerAds?.length > 0 && (
                        <NotificationV2
                            htmlText={searchResultsDisclaimerText}
                            customClass="notification-banner sub"
                        />
                    )
                )}
            </>
        );
    }
}
